// Teeinblue + Horizon theme cart sync
(function() {
  function updateCart() {
    const root = window.Shopify?.routes?.root || '/';
    fetch(root + 'cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count;
        // Horizon theme cart count selectors
        document.querySelectorAll(
          '.header-actions__cart-count, .cart-count-bubble, [data-cart-count], .count'
        ).forEach(el => { el.textContent = count; });
        // Refresh cart drawer section (Horizon/Dawn pattern)
        fetch(root + '?section_id=cart-drawer')
          .then(r => r.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('cart-drawer-component, [id*="cart-drawer"]');
            const currentDrawer = document.querySelector('cart-drawer-component, [id*="cart-drawer"]');
            if (newDrawer && currentDrawer) {
              currentDrawer.innerHTML = newDrawer.innerHTML;
            }
          })
          .catch(() => {});
      })
      .catch(() => {});
  }

  // Intercept Fetch (Teeinblue likely uses this)
  const origFetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    return origFetch.apply(this, args).then(res => {
      if (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change')) {
        setTimeout(updateCart, 400);
      }
      return res;
    });
  };

  // Intercept XMLHttpRequest
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('load', function() {
      if (url && (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change'))) {
        setTimeout(updateCart, 400);
      }
    });
    return origOpen.apply(this, arguments);
  };
})();